const token = localStorage.getItem('harvard_token');
const membershipStatus = localStorage.getItem('harvard_membershipStatus');
const data = JSON.parse(localStorage.getItem('harvard_data'));

export const initialState = {
  isAuthorized: token ? true : false,
  membershipStatus: null || membershipStatus,
  data: data || {},
};
